var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.66626,
    width: 30.8293,
    height: 37.3337,
    rx: 15.4147,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.4138 15.8132L11.8805 20.9478C11.5853 21.3768 11.0588 21.4348 10.7045 21.0773C10.3503 20.7198 10.3024 20.0822 10.5976 19.6532L14.7724 13.5865C15.1062 13.1014 15.7215 13.1014 16.0553 13.5865L20.2301 19.6532C20.5253 20.0822 20.4774 20.7198 20.1232 21.0773C19.7689 21.4348 19.2424 21.3768 18.9472 20.9478L15.4138 15.8132Z",
    fill: "#B5B5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72825 20.3003C9.0386 20.3003 8.55596 20.9819 8.78501 21.6324L11.3685 28.9696C11.7912 30.1701 12.9254 30.9732 14.1982 30.9732H16.6293C17.9022 30.9732 19.0364 30.17 19.4591 28.9694L22.042 21.6324C22.271 20.9819 21.7884 20.3003 21.0987 20.3003H9.72825ZM17.0838 26.3667C17.0838 27.4836 16.3362 28.389 15.4139 28.389C14.4916 28.389 13.744 27.4836 13.744 26.3667C13.744 25.2499 14.4916 24.3445 15.4139 24.3445C16.3362 24.3445 17.0838 25.2499 17.0838 26.3667Z",
    fill: "#B5B5C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#EEF6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 20.1226C22.6845 20.1226 24.0594 18.7517 24.0594 17.0633C24.0594 15.3788 22.6886 14.0039 21.0001 14.0039C19.3116 14.0039 17.9407 15.3748 17.9407 17.0633C17.9407 18.7517 19.3156 20.1226 21.0001 20.1226Z",
    fill: "#009EF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8837 21.0712L24.1641 20.8582L21.0002 24.0261L17.8363 20.8582L17.1167 21.0712C15.2513 21.634 14.001 23.3145 14.001 25.2603V28.8544H28.0073V25.2603C28.0033 23.3145 26.749 21.6341 24.8836 21.0712H24.8837Z",
    fill: "#009EF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25.4612 17.067C25.4612 17.871 25.2159 18.6228 24.7978 19.2459C24.9184 19.262 25.039 19.2741 25.1597 19.2741C26.7758 19.2741 28.0904 17.9635 28.0904 16.3434C28.0904 14.7313 26.7798 13.4207 25.1597 13.4207C24.6411 13.4207 24.1466 13.5614 23.7084 13.8106C24.7657 14.5101 25.4612 15.7081 25.4612 17.067L25.4612 17.067Z",
    fill: "#009EF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.8621 20.1267L28.1626 19.9216L27.1375 20.9468C28.5365 21.8996 29.4089 23.4876 29.4089 25.2605V27.5681H31.837V24.1308C31.837 22.2735 30.639 20.6654 28.8621 20.1266L28.8621 20.1267Z",
    fill: "#009EF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.8441 19.2701C16.9647 19.2701 17.0893 19.2581 17.2059 19.242C16.7878 18.6189 16.5426 17.8711 16.5426 17.0631C16.5426 15.7042 17.2381 14.5062 18.2954 13.8027C17.8572 13.5575 17.3627 13.4167 16.8441 13.4167C15.228 13.4167 13.9134 14.7273 13.9134 16.3394C13.9134 17.9596 15.228 19.2702 16.8441 19.2702L16.8441 19.2701Z",
    fill: "#009EF6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.8663 20.9466L13.8412 19.9214L13.1457 20.1264H13.1417C11.3607 20.6611 10.1667 22.2692 10.1667 24.1266V27.5679H12.5989V25.2603C12.5989 23.4914 13.4673 21.9034 14.8663 20.9466L14.8663 20.9466Z",
    fill: "#009EF6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customersIcon.dac29baad82bae4de088b2a2dd97cfbe.svg";
export { ForwardRef as ReactComponent };